import {Alert, Button} from 'antd';
import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {ApiQuery} from '../../../gen/api';
import {SIGN_IN_CHECK_MS, signInWarning} from './signIn';

/** The eBay sign-in warning on every page but the eBay page, which shows its own. */
export const EbaySignInBanner: React.FC = () => {
    const navigate = useNavigate();
    const {pathname} = useLocation();
    const accountQuery = ApiQuery.useAdminEbayAccountQuery({
        staleTime: SIGN_IN_CHECK_MS,
        refetchInterval: SIGN_IN_CHECK_MS,
    });
    const account = accountQuery.data?.account;
    const warning = account && signInWarning(account);

    if (!warning || pathname.startsWith('/ebay')) {
        return null;
    }
    return (
        <Alert
            type={warning.type}
            showIcon
            banner
            message={warning.message}
            description={warning.description}
            action={
                <Button
                    size="small"
                    onClick={() => navigate('/ebay')}
                >
                    Open the eBay page
                </Button>
            }
            style={{marginBottom: 16}}
        />
    );
};
